































import Vue from 'vue';
import VatsAPI from '@/Shared/VatsAPI';
import { ReportType } from './Enums';
import LocationBasedMixin from '@/Shared/LocationBasedMixin';
import mixins from 'vue-typed-mixins';
import Editor from '@tinymce/tinymce-vue';
import { Settings } from 'tinymce';
import tinymceSetup from '@/Shared/TinymceSetup';

const reportManagement = mixins(LocationBasedMixin).extend({
    props: ['location'],
    components: { Editor },
    data() {
        return {
            validationErrors: {} as { [key: string]: string[] },
            reportType: ReportType,
            reportTypeNames: Object.keys(ReportType).filter(k => typeof (ReportType as any)[k] !== 'string'),
            selectedReport: null as ReportType | null,
            showDiv: 'true',
            tinymceContent: this.$i18n.t('admin.reportManagement.tinymceContent').toString(),
            tinymceInit: {
                height: 500,
                menubar: false,
                skin_url: tinymceSetup.skinsDirectory,
                content_css: tinymceSetup.contentCssPath,
                toolbar:
                    'undo redo | formatselect | bold italic backcolor | \
                    alignleft aligncenter alignright alignjustify | \
                    bullist numlist outdent indent | removeformat | help',
                plugins: tinymceSetup.importedPlugins,
            } as Settings
        };
    },
    methods: {
        async saveReportContent() {
            try {
                if (this.selectedReport != null) {
                    const endString = `${this.location}/reports/${this.selectedReport}/UpdateReportTemplate`;
                    await VatsAPI.post(endString, JSON.stringify(this.tinymceContent), {
                        headers: {
                            ['content-type']: 'application/json'
                        }
                    });
                    this.$bvToast.toast(this.$i18n.t('admin.reportManagement.reportSavedMessage').toString(), {
                        title: this.$i18n.t('common.save').toString(),
                        autoHideDelay: 5000
                    });
                    this.refreshContent();
                }
            }
            catch (e) {
                this.$bvToast.toast(this.$i18n.t('admin.reportManagement.saveReportError').toString(), {
                    title: this.$i18n.t('common.error').toString(),
                    autoHideDelay: 5000
                });
                throw e;
            }
        },
        async refreshContent() {
            try {
                if (this.selectedReport != null) {
                    const url = `${this.location}/reports/GetReportTemplate?reportType=${ReportType[this.selectedReport].toString()}`;
                    const axiosResponse = await VatsAPI.get<string[]>(url);
                    this.tinymceContent = axiosResponse.data.toString();
                }
            }
            catch (e) {
                this.$bvToast.toast(this.$i18n.t('admin.reportManagement.refreshReportError').toString(), {
                    title: this.$i18n.t('common.error').toString(),
                    autoHideDelay: 5000
                });
                throw e;
            }
        }
    },
});

export default reportManagement;

